import { createContext, useContext, memo } from 'react'

const DeviceTypeContext = createContext()

function Provider({ children, deviceType }) {
  return <DeviceTypeContext.Provider value={deviceType}>{children}</DeviceTypeContext.Provider>
}

export const DeviceTypeProvider = memo(Provider)

export const useDeviceType = () => useContext(DeviceTypeContext)
